export const TERMS_AND_CONDITIONS_UNLEASH_TOGGLE = "enabled_terms_and_conditions"
